import { useContext } from 'react'

import { EntitiesColorsContext } from './context'

export const useEntitiesColors = () => {
  const context = useContext(EntitiesColorsContext)

  if (!context) {
    throw new Error('useEntitiesColors must be used within a EntitiesColorsProvider')
  }

  return context
}
